import CryptoJS from 'crypto-js';

// Verschlüsselungsschlüssel - in Produktion sollte dies aus Umgebungsvariablen kommen
const ENCRYPTION_KEY = 'twilio-whitelist-secret-key-2025';

export class EncryptionService {
  static encrypt(text: string): string {
    return CryptoJS.AES.encrypt(text, ENCRYPTION_KEY).toString();
  }

  static decrypt(encryptedText: string): string {
    const bytes = CryptoJS.AES.decrypt(encryptedText, ENCRYPTION_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  }
}

// Vordefinierte verschlüsselte Credentials
// Diese sollten durch echte Twilio-Credentials ersetzt werden
export const ENCRYPTED_CREDENTIALS = {
  // Beispiel verschlüsselte Werte - ersetze mit echten Credentials
  SID: EncryptionService.encrypt('ACe66d1e842bfb9b3013f4b4ee14e2ce85'),
  TOKEN: EncryptionService.encrypt('72a580aa1371045cd0482bf23c768d1a')
};
